import { render, staticRenderFns } from "./PackListItems.vue?vue&type=template&id=af250fa4&scoped=true&"
import script from "./PackListItems.vue?vue&type=script&lang=js&"
export * from "./PackListItems.vue?vue&type=script&lang=js&"
import style0 from "./PackListItems.vue?vue&type=style&index=0&id=af250fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af250fa4",
  null
  
)

export default component.exports